<template>
    <v-card color="#FFE5B4">
        <v-card-subtitle class="justify-center">This lead is also present in Ares as owner with a "LB" accommodation</v-card-subtitle>
        <v-divider></v-divider>
        <v-row no-gutters v-for="owner in filteredOwners" :key="owner.eign_code">
            <v-col cols=12 class="px-4 py-1"><span>{{ owner.eign_naam }}</span> (<span class="linkto" @click="openEign(owner.eign_encrid)">{{ owner.eign_code }}</span>)</v-col>
        </v-row>
        <v-row no-gutters v-for="acco in accos" :key="acco.huis_code">
            <v-col cols=12 class="px-4 py-1"><span>{{ acco.huis_naam }}</span> (<span class="linkto" @click="openHuis(acco.huis_encrid)">{{ acco.huis_code }}</span>)</v-col>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        components: {
        },
        props: {
            owners: {
                type: Array,
                required: true,
            },
            accos: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
            }
        },
        computed: {
            filteredOwners: function () {
                let seen = new Set();
                return this.owners.filter(owner => {
                    if (seen.has(owner.eign_code)) return false;
                    seen.add(owner.eign_code);
                    return true;
                });
            }
        },  
        methods: {
            openEign(encrid) {
                let route = this.$router.resolve({ path: '/eign/onEign/' + encrid}); 
                window.open(route.href, '_blank');
            },
            openHuis(encrid) {
                let route = this.$router.resolve({ path: '/huis/onHuis/' + encrid}); 
                window.open(route.href, '_blank');
            },
        }
    }
</script>

<style scoped>
.linkto {
    color: #1976D2;
    cursor: pointer;
    text-decoration: underline;
}
</style>

